import { useContext, useEffect, useState } from "react"
import { FormLabel, InlineLoading } from "carbon-components-react"
import "../SpeakerBio/SpeakerBio.scss"
import TileWrapper from "ui/TileWrapper/TileWrapper"
import MainContext from "context/MainContext"

const HideSpeakers = ({ options, loading, onChange, ...props }) => {

    const context = useContext(MainContext)
    const [value, setValue] = useState([])

    useEffect(() => {
        setValue(props.initialValue || [])
    }, [props.initialValue])

    const toggle = (itemId) => {
        let newValue = value
        if (value?.includes(itemId)) {
            newValue = value.filter(item => item !== itemId)
        }
        else {
            newValue = value.concat(itemId)
        }
        onChange(newValue)
    }

    const content = (
        <>
            {
                loading ? (
                    <InlineLoading />
                ) :
                    options?.length ?
                        options.map((item, index) => {
                            return (
                                <TileWrapper
                                    titleComponent={"div"}
                                    key={`speakers-list-item-${item.id}-${index}`}
                                    title={`${item.firstname} ${item.lastname}${context.user.is_admin ? ` (${item.id})` : ""}`}
                                    // onTitleClicked={props.onClick}
                                    disableTitlePadding={true}
                                    selectable={true}
                                    selected={value?.includes(item.id)}
                                    onChange={() => toggle(item.id)}
                                />
                            )
                        }) : (
                            <div>
                                Empty
                            </div>
                        )
            }
        </>
    )

    return (
        <div className="speaker-bio">
            {
                props.labelText ? (
                    <div>
                        <FormLabel>
                            {props.labelText}
                        </FormLabel>
                    </div>
                ) : null
            }

            {content}
        </div>

    )
}

export default HideSpeakers